/**
 * Contact API Service
 * Manages all contact-related API calls
 */

import { post } from './apiClient';

interface ContactSalesFormData {
  full_name: string;
  email: string;
  company: string;
  number_of_employees: string;
  message: string;
}

interface ScheduleDemoFormData {
  full_name: string;
  email: string;
  company: string;
  position: string;
  preferred_date: string;
  preferred_time: string;
}

interface ContactResponse {
  success: boolean;
  message: string;
}

export const contactApi = {
  /**
   * Send a message to the sales team
   * @param data - Contact form data
   */
  messageSales: (data: ContactSalesFormData) => 
    post<ContactResponse>('/contact/message-sales', data),
    
  /**
   * Schedule a product demonstration
   * @param data - Demo scheduling form data
   */
  scheduleDemo: (data: ScheduleDemoFormData) =>
    post<ContactResponse>('/contact/schedule-demo', data),
};

export default contactApi;